export default "__VITE_ASSET__cb619d5a__"